/**
 * Calendario de pagos (P39) · EXCLUSIVO de Mesa de Control. Pagos
 * programados (solicitudes autorizadas · la fecha la fija el último nivel)
 * con KPIs y semáforo, y reprogramación de la fecha con motivo.
 */
import { axiosClient } from "@/shared/api/axios-client";

export type EstadoPago = "Vencido" | "PagaHoy" | "Programado" | "Depositado";

export interface PagoProgramado {
  solicitudId: string;
  numeroSolicitud: number;
  folio: string;
  organizacionId: string | null;
  organizacionNombre: string | null;
  proveedorNumero: number | null;
  proveedorRazonSocial: string | null;
  cuentaBancaria: string | null;
  clabe: string | null;
  descripcion: string | null;
  cantidadCfdis: number;
  importe: number;
  moneda: string | null;
  documentoContable: string | null;
  depositado: boolean;
  fechaSolicitud: string;
  fechaPago: string;
  diasProgramacion: number;
  estado: EstadoPago;
}

export interface TotalPorMoneda {
  moneda: string;
  total: number;
  cantidad: number;
}

export interface CalendarioKpis {
  totalesPorMoneda: TotalPorMoneda[];
  totalPagos: number;
  pagosHoy: number;
  pagosProximos7: number;
  pagosVencidos: number;
}

export interface CalendarioDePagos {
  pagos: PagoProgramado[];
  kpis: CalendarioKpis;
  desde: string;
  hasta: string;
  /** Total de pagos del set filtrado (== kpis.totalPagos · explícito para paginar). */
  total: number;
  /** Página devuelta en `pagos` · null cuando la respuesta trae el set completo. */
  page: number | null;
  pageSize: number | null;
}

export interface CalendarioParams {
  desde?: string;
  hasta?: string;
  organizacionId?: string;
  moneda?: string;
  /** Opcional · sin `page` el server devuelve TODOS los pagos del periodo. */
  page?: number;
  pageSize?: number;
}

export async function obtenerCalendarioDePagos(
  params: CalendarioParams = {}
): Promise<CalendarioDePagos> {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v) qs.set(k, String(v));
  }
  const s = qs.toString();
  const { data } = await axiosClient.get<CalendarioDePagos>(
    `/api/autorizacion/calendario-pagos${s ? `?${s}` : ""}`
  );
  return data;
}

export async function reprogramarFechaPago(args: {
  solicitudId: string;
  nuevaFecha: string;
  motivo: string;
}): Promise<void> {
  await axiosClient.post(
    `/api/autorizacion/${args.solicitudId}/reprogramar-fecha-pago`,
    { nuevaFecha: args.nuevaFecha, motivo: args.motivo }
  );
}
